/**
 * Plain object Packlink's API response representation.
 *
 */

class DisclaimerManagementMapper {
  static createModelFromResponse(response) {
    return {
      showDisclaimer: response.show_disclaimer
    };
  }
  static getWeightDeviationPayload(data) {
    return {
      to_country: data.toCountry,
      packages: data.packages
    };
  }
}

export { DisclaimerManagementMapper };
//# sourceMappingURL=DisclaimerManagementMapper.js.map
